module.exports = __webpack_public_path__ + "static/media/Avatar7.63cd3aa2.svg";